import { render, staticRenderFns } from "./roleDialog.vue?vue&type=template&id=2aa673ec&"
import script from "./roleDialog.vue?vue&type=script&lang=js&"
export * from "./roleDialog.vue?vue&type=script&lang=js&"
import style0 from "./roleDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports